import './index.scss'
import { Controller as BaseController } from 'stimulus'
import moment from 'moment'
import I18n from '@app/javascript/i18n/index.js.erb'
import { formatDateTimeWithLocalTimeZone } from '@app/javascript/utils/timezone_utils.js'

/**
 * @namespace DurationFields
 */
export class Controller extends BaseController {
  static targets = ['startInput', 'endField', 'endInput', 'liveRegion']
  static values = { formatDBInputWithLocalTimezone: Boolean }

  /**
   * Check if the selected end date comes after the selected start date
   */
  validateEndDatetime() {
    const startDate = this.startInputTarget.value
    const endDate = this.endInputTarget.value

    const isValid = moment(endDate).isAfter(startDate)
    this.endFieldTarget.classList.toggle('is-invalid', !isValid)

    this.liveRegionTarget.textContent = isValid
      ? ''
      : I18n.t('actions.create.duration.error.end_before_start')
  }

  /**
   * When a user changes the Start Datetime,
   * auto-update the End Datetime to be the same date, an hour later.
   * {@link https://momentjs.com/docs/#/displaying/format/}
   * {@link https://flatpickr.js.org/formatting/#date-formatting-tokens}
   * {@link https://flatpickr.js.org/formatting/#time-formatting-tokens}
  */
  updateEndDatetime(event) {
    const newEndDatetimeMoment = moment(event.target.value).add(1, 'hours')

    // Flatpickr allows devs to "show the user a readable date (as per altFormat),
    // but return something totally different to the server."
    // We've decided to take advantage of this, in order to meet design requirements.
    // The way Flatpickr does this is by rendering a new text input that's visible in the UI,
    // and then changing the original input to type="hidden".
    // {@link https://flatpickr.js.org/options}

    // Update the base input (which is now hidden) for form submission
    // - Four-digit year................ Flatpickr: Y   Moment.js: YYYY
    // - Month, with leading zero....... Flatpickr: m   Moment.js: MM
    // - Day, with leading zero......... Flatpickr: d   Moment.js: DD
    // - Hour, 24-hour format........... Flatpickr: H   Moment.js: HH
    // - Minutes, with leading zero..... Flatpickr: i   Moment.js: i
    // @see {InputDatetime.initialize}
    const newEndDatetimeStringForDatabase = this.formatDatetimeMomentForDB(newEndDatetimeMoment)
    $(this.endInputTarget).val(newEndDatetimeStringForDatabase)

    // Update "alternate" input, generated by Flatpickr, for the user
    // - Month, without leading zero.... Flatpickr: n   Moment.js: M
    // - Day, without leading zero...... Flatpickr: j   Moment.js: D
    // - Four-digit year................ Flatpickr: Y   Moment.js: YYYY
    // - Hour, 12-hour format........... Flatpickr: h   Moment.js: h
    // - Minutes, without leading zero.. Flatpickr: i   Moment.js: mm
    // - AM/PM.......................... Flatpickr: K   Moment.js: A
    // @see {InputDatetime.initialize}
    const newEndDatetimeStringForUser = newEndDatetimeMoment.format('M/D/YYYY h:mmA')
    const altInput = $(this.endInputTarget).next('input')
    altInput.val(newEndDatetimeStringForUser)
  }

  // PRIVATE

  formatDatetimeMomentForDB(datetimeMoment) {
    let formatedDatetime = datetimeMoment.format('YYYY-MM-DD HH:mm')
    if (this.formatDBInputWithLocalTimezoneValue) {
      formatedDatetime = formatDateTimeWithLocalTimeZone(formatedDatetime)
    }
    return formatedDatetime
  }
}
